import { createFileRoute, redirect } from "@tanstack/react-router";
import { LearningJourneys } from "@/lib/lazyPages";
import { SEO } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";
import { mightHaveSession } from "@/lib/hasStoredSession";

const EARLY_SIGNED_OUT_REDIRECT = `(function(){try{var l=location;if(/[?&#](code|access_token|refresh_token|error_description)=/.test(l.search+l.hash))return;var s=localStorage;for(var i=0;i<s.length;i++){var k=s.key(i);if(k&&/^sb-.*-auth-token$/i.test(k)&&s.getItem(k))return;}l.replace('/auth');}catch(e){}})();`;

export const Route = createFileRoute("/learning-journeys")({
  // Speed only, not security: a visitor with no stored session on this device
  // goes straight to sign-in instead of downloading the whole dashboard first
  // (measured ~166 requests before the in-page redirect). The page still
  // checks the real session itself.
  beforeLoad: () => {
    if (!mightHaveSession()) {
      throw redirect({ to: "/auth", replace: true });
    }
  },
  // Signed-in-only page: every signed-out visitor (crawlers included) is sent to
  // /auth, which is noindex. Declaring this page noindex removes the old
  // contradiction where it was advertised as indexable in the sitemap while
  // being gated in practice. The Course/Offer + FAQ structured data moved to
  // /subscription, which is genuinely indexable.
  head: () => {
    const base = seoHead({ ...SEO.learningJourneys, noindex: true });
    return {
      ...base,
      // Same check as beforeLoad, but for a fresh page load: runs in <head>
      // before the dashboard code downloads, so signed-out visitors skip it.
      scripts: [...((base as { scripts?: unknown[] }).scripts ?? []), { children: EARLY_SIGNED_OUT_REDIRECT }],
    } as typeof base;
  },
  component: LearningJourneys,
});
